import LucideGlyph from 'lucide-react/dist/esm/icons/sliders-horizontal.mjs';
import type { JSX } from 'react';
import { Icon } from '@solidops/ui/icon';
import type { IconProps } from '@solidops/ui/icon';

export function SlidersIcon(props: IconProps): JSX.Element {
  return <Icon glyph={LucideGlyph} size={24} fillable={false} {...props} />;
}
